import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import GoogleMapReact from "google-map-react";

const MapPin = () => (
  <Box
    sx={{
      transform: "translate(-50%, -100%)",
      color: "error.main",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <PlaceIcon sx={{ fontSize: 36 }} />
  </Box>
);

const LocationMap = ({ lat, lon, height = 220, label = "" }) => {
  const hasCoords =
    Number.isFinite(Number(lat)) && Number.isFinite(Number(lon));

  if (!hasCoords) {
    return (
      <Box
        sx={{
          height,
          borderRadius: 2,
          bgcolor: "action.hover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <PlaceIcon color="disabled" />
        <Typography variant="body2" color="text.secondary">
          Map unavailable — coordinates not found
        </Typography>
      </Box>
    );
  }

  const center = { lat: Number(lat), lng: Number(lon) };
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  if (!apiKey) {
    return (
      <Box
        sx={{
          height,
          borderRadius: 2,
          bgcolor: "grey.100",
          border: "1px dashed",
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 0.5,
          p: 2,
          textAlign: "center",
        }}
      >
        <PlaceIcon color="action" />
        <Typography variant="subtitle2" fontWeight={700}>
          {label || "Location"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Lat {Number(lat).toFixed(4)}, Lon {Number(lon).toFixed(4)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height, width: "100%", borderRadius: 2, overflow: "hidden" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: apiKey, language: "en", region: "IN" }}
        defaultCenter={center}
        center={center}
        defaultZoom={12}
        yesIWantToUseGoogleMapApiInternals
      >
        <MapPin lat={center.lat} lng={center.lng} />
      </GoogleMapReact>
    </Box>
  );
};

LocationMap.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
};

export default LocationMap;
